module.exports = __webpack_public_path__ + "img/Visa_Brandmark_Blue_RGB_2021.b8094d94.svg";